import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FuseDeleteDialogComponent} from '../delete-dialog/delete-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DocumentsService} from '../../services/documents.service';
import {DomSanitizer} from '@angular/platform-browser';
import { AddPictureComponent } from '../../../main/pages/e-learning/add-picture-modal/add-picture.component';

@Component({
    selector: 'document-uploader',
    templateUrl: './document-uploader.component.html',
    styleUrls: ['./document-uploader.component.scss'],
    standalone: false
})

export class DocumentUploaderComponent implements OnChanges {
  @Input() uploadedFiles;
  @Input() picturePreview = false;
  @Input() hideUploadButton = false;
  @Input() cropBeforeLoad = false;
  @Output() loadFiles = new EventEmitter();
  id = Date.now().toString(36) + Math.random().toString(36).substr(2);
  newFiles = [];
  constructor(public dialog: MatDialog, private documentService: DocumentsService,
              private sanitized: DomSanitizer) {
  }

  ngOnChanges(changes) {
    if (this.uploadedFiles && this.uploadedFiles.length) {
      for (let item of this.uploadedFiles) {
        item.url = item.name;
        item.type = item.name.substring(item.name.lastIndexOf('.') + 1 , item.name.length);
        item.name = item.name.split('|_|')[ 1 ];
      }
    }
  }

  getFile(name) {
    return this.documentService.getFileStream(name);
  }

  handleInputChange(event: any) {
    event.preventDefault();
    if (this.cropBeforeLoad) {
      const dialogRef = this.dialog.open(AddPictureComponent ,
        { panelClass: 'contact-form-dialog',
        width: 'auto',
          data: {event}
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          res.imgSrc = this.sanitized.bypassSecurityTrustResourceUrl(URL.createObjectURL(res));
          this.newFiles.push(res);
          this.loadFiles.emit(this.newFiles);
        }
      });
    } else {
      for (let file of event.target.files){
        file.imgSrc = this.sanitized.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
        this.newFiles.push(file);
      }
    }
    this.loadFiles.emit(this.newFiles);
  }

  removeFile (e) {
    const index = this.newFiles.indexOf(e);
    if (index > -1) {
      this.newFiles.splice(index, 1);
    }
    this.loadFiles.emit(this.newFiles);
  }

  removeFileFromUpload (e) {
    // console.log(e);
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const index = this.uploadedFiles.indexOf(e);
        if (index > -1) {
          this.uploadedFiles.splice(index , 1);
        }
        this.documentService.deleteDocument(e.id).subscribe((res) => {
          if (res) {

          }
        });
      }
    });

  }
}
